export const REFERENTIEL_LOAD_REQUEST = 'REFERENTIEL_LOAD_REQUEST';
export const REFERENTIEL_LOAD_SUCCESS = 'REFERENTIEL_LOAD_SUCCESS';
export const REFERENTIEL_LOAD_FAILURE = 'REFERENTIEL_LOAD_FAILURE';

export const chargerReferentiel = () => ({ type: REFERENTIEL_LOAD_REQUEST });
